'use strict'

export default (mockAxios) => {
  // 自分が代理指定しているユーザー一覧情報（max2人）を取得
  mockAxios.onGet(`/agents`).reply(200, {
    'success': true,
    'data': [
      {
        'id': 1,
        'user_state': 0,
        'full_name': '山田 一郎'
      }
    ],
    'pagination': {
      'page_count': 5,
      'current_page': 1,
      'has_next_page': true,
      'has_prev_page': false,
      'count': 55,
      'limit': 10
    }
  })

  // 代理操作ユーザー情報を更新
  mockAxios.onPost(`/agents`).reply(201, {
    'success': true,
    'data': []
  })

  // 自分が代理指定されているユーザー一覧情報を取得
  mockAxios.onGet(`/agents/requesters`).reply(200, {
    'success': true,
    'data': [
      {
        'id': 1,
        'user_state': 0,
        'post': '課長',
        'defgroup': 102,
        'full_name': '山田 一郎',
        'groups': [
          {
            'id': 1,
            'name': '組織１'
          }
        ]
      }
    ],
    'pagination': {
      'page_count': 5,
      'current_page': 1,
      'has_next_page': true,
      'has_prev_page': false,
      'count': 55,
      'limit': 10
    }
  })

  // 代理操作を開始
  mockAxios.onPost(`/agents/login`).reply(200, {
    'success': true,
    'data': {
      'token': '<YOUR TOKEN>'
    }
  })

  // 代理操作を終了
  mockAxios.onPost(`/agents/logout`).reply(200, {
    'success': true,
    'data': {
      'token': '<YOUR TOKEN>'
    }
  })
}



// WEBPACK FOOTER //
// ./src/repositories/mock/agentRepositoryMock.js